import React, { useContext, useMemo, useState } from 'react';
import SessionContext from '@providers/Session/SessionContext';
import { useTranslation } from 'react-i18next';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { ApplicationsProps } from '@config/useApps';
import SectionPages from './SectionPages';
import SectionApplications from './SectionApplications';
import * as S from './styles';

interface PagesMenuProps {
  eventsAlertsData: any;
  alreadyViewEvents: any;
  setAlreadyViewEvents: any;
  setUserAttributes: any;
}

const PagesMenu = ({
  eventsAlertsData,
  alreadyViewEvents,
  setAlreadyViewEvents,
  setUserAttributes,
}: PagesMenuProps) => {
  const { t } = useTranslation('main');
  const { selectedApp, getAppByName, isNotChildOfRoot } =
    useContext(SessionContext);
  const [openedLevel, setOpenedLevel] = useState('pages');

  const selectedApplication: ApplicationsProps | undefined = useMemo(
    () => getAppByName(selectedApp),
    [getAppByName, selectedApp],
  );

  const selectedTitle = useMemo(() => {
    const treatedName: string = selectedApplication?.name ?? '';

    return t(
      `apps.${
        isNotChildOfRoot && selectedApplication?.alternativeName
          ? selectedApplication?.alternativeName
          : treatedName
      }`,
    );
  }, [
    isNotChildOfRoot,
    selectedApplication?.alternativeName,
    selectedApplication?.name,
    t,
  ]);

  return (
    <S.Container>
      {openedLevel === 'pages' && (
        <S.ApplicationSelected onClick={() => setOpenedLevel('applications')}>
          <div className="selected-app-title">
            {selectedApplication?.icon}
            <h1>{selectedTitle}</h1>
          </div>
          <div className="selected-app-icon">
            <UpOutlined />
            <DownOutlined />
          </div>
        </S.ApplicationSelected>
      )}
      <S.Content>
        {openedLevel === 'pages' ? (
          <SectionPages
            selectedApplication={selectedApplication}
            eventsAlertsData={eventsAlertsData}
            alreadyViewEvents={alreadyViewEvents}
            setAlreadyViewEvents={setAlreadyViewEvents}
            setUserAttributes={setUserAttributes}
          />
        ) : (
          <SectionApplications setOpenedLevel={setOpenedLevel} />
        )}
      </S.Content>
    </S.Container>
  );
};

export default PagesMenu;
